import { useEffect, useRef, useState } from 'react';

const TTL_MS = 10 * 60 * 1000; // 10 minutos

export function useCachedInsight(cacheKey, fetchFn, enabled = true) {
  const [state, setState] = useState({ loading: true, text: '', error: false });
  const ran = useRef(false);

  useEffect(() => {
    if (!enabled || !cacheKey || ran.current) return;
    ran.current = true;

    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      const { text, timestamp } = JSON.parse(cached);
      if (Date.now() - timestamp < TTL_MS) {
        setState({ loading: false, text, error: false });
        return;
      }
    }

    setState({ loading: true, text: '', error: false });
    fetchFn()
      .then((text) => {
        sessionStorage.setItem(cacheKey, JSON.stringify({ text, timestamp: Date.now() }));
        setState({ loading: false, text, error: false });
      })
      .catch(() => {
        setState({ loading: false, text: '', error: true });
      });
  }, [cacheKey, enabled]);

  return state;
}